import { useNavigate, useLocation } from "react-router-dom";
import { SvgIconTypeMap } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import style from "./Sidebar.module.css";

interface Props {
  path: string;
  label: string;
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string };
  onClick?: () => void;
  indent?: boolean;
}

export function SidebarItem({ path, label, icon: Icon, onClick, indent }: Props) {
  const navigate = useNavigate();
  const location = useLocation();
  const isActive =
    location.pathname === path || location.pathname.startsWith(path + "/");

  const handleClick = () => {
    navigate(path);
    onClick?.();
  };

  return (
    <button
      type="button"
      className={[
        style.sidebarItem,
        isActive ? style.sidebarItemActive : "",
        indent ? style.sidebarItemIndent : "",
      ].join(" ")}
      onClick={handleClick}
    >
      <Icon className={style.sidebarItemIcon} />
      <span className={style.sidebarLabel}>{label}</span>
    </button>
  );
}
